/**
 * ServiceStepsTab — thin adapter that wires the "Service Steps" workspace tab
 * to the container/presentation stack.
 *
 * Rendering pipeline:
 *   ServiceStepsTab (adapter)
 *     → ServiceStepsContainer (derives step statuses from request)
 *       → ServiceStepsView (pure presentational renderer)
 *
 * To customise steps for a service type, edit SERVICE_STEP_DEFINITIONS in
 * ../constants.ts — no changes are needed here or in ServiceStepsView.
 */
import type { CustomerServiceRequestResponse } from '@/api/service-requests';
import { ServiceStepsContainer } from './service-steps-container';

interface ServiceStepsTabProps {
  request: CustomerServiceRequestResponse;
}

export function ServiceStepsTab({ request }: ServiceStepsTabProps) {
  return <ServiceStepsContainer request={request} />;
}
